"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UrlUtils = _interopRequireDefault(require("@icare/core/lib/utils/UrlUtils"));

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _Message = _interopRequireDefault(require("@icare/components/lib/Message"));

var _Spinner = _interopRequireDefault(require("@icare/components/lib/Spinner"));

var _Form = _interopRequireDefault(require("@icare/forms/lib/models/Form"));

var _GenericForm = _interopRequireDefault(require("@icare/forms/lib/components/GenericForm"));

var _FormErrorSummary = _interopRequireDefault(require("@icare/forms/lib/components/FormErrorSummary"));

var _LayoutField = _interopRequireDefault(require("@icare/forms/lib/components/LayoutField"));

var _RichText = _interopRequireDefault(require("@icare/components/lib/RichText"));

var _Layout = _interopRequireDefault(require("@icare/layouts/lib/Layout"));

var _ExpiredLinkPage = _interopRequireDefault(require("./ExpiredLinkPage"));

var _IdentityService = _interopRequireDefault(require("../../services/IdentityService"));

var _IdentityUtils = _interopRequireDefault(require("../../utils/IdentityUtils"));

var _constants = require("./constants/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var schema = {
  id: "identity",
  fields: [{
    id: "password",
    type: "password",
    label: "Create password",
    required: true,
    requiredMessage: "Please enter your new password",
    validators: [{
      type: "isPassword",
      data: {
        message: "Your password doesn\u2019t meet the requirements above. Please try again."
      }
    }, {
      type: "isLength",
      data: {
        message: "Your new password has too many characters, please ensure your new password is less than {max} characters",
        options: {
          max: 100
        }
      }
    }],
    data: {
      width: "l"
    }
  }, {
    id: "securityQuestion",
    type: "select",
    label: "Security question",
    options: [{
      label: "Please select",
      key: "Please select",
      value: null
    }, {
      label: "What is your mother\u2019s maiden name?",
      key: "What is your mother\u2019s maiden name?",
      value: "What is your mother\u2019s maiden name?"
    }, {
      label: "What is the name of your first pet?",
      key: "What is the name of your first pet?",
      value: "What is the name of your first pet?"
    }, {
      label: "What was the name of your first school?",
      key: "What was the name of your first school?",
      value: "What was the name of your first school?"
    }, {
      label: "Where did you travel for the first time?",
      key: "Where did you travel for the first time?",
      value: "Where did you travel for the first time?"
    }, {
      label: "When is your wedding anniversary?",
      key: "When is your wedding anniversary?",
      value: "When is your wedding anniversary?"
    }, {
      label: "Who is your favourite sports team?",
      key: "Who is your favourite sports team?",
      value: "Who is your favourite sports team?"
    }, {
      label: "What was the model of your first car?",
      key: "What was the model of your first car?",
      value: "What was the model of your first car?"
    }, {
      label: "When you were young, what did you want to be when you grew up?",
      key: "When you were young, what did you want to be when you grew up?",
      value: "When you were young, what did you want to be when you grew up?"
    }, {
      label: "Who was your childhood hero?",
      key: "Who was your childhood hero?",
      value: "Who was your childhood hero?"
    }, {
      label: "What was your childhood nickname?",
      key: "What was your childhood nickname?",
      value: "What was your childhood nickname?"
    }, {
      label: "What is your oldest sibling\u2019s birthday year?",
      key: "What is your oldest sibling\u2019s birthday year?",
      value: "What is your oldest sibling\u2019s birthday year?"
    }, {
      label: "What is the name of the town or city were you born in?",
      key: "What is the name of the town or city were you born in?",
      value: "What is the name of the town or city were you born in?"
    }, {
      label: "What is the name of the street you grew up on?",
      key: "What is the name of the street you grew up on?",
      value: "What is the name of the street you grew up on?"
    }, {
      label: "What is your father\u2019s middle name?",
      key: "What is your father\u2019s middle name?",
      value: "What is your father\u2019s middle name?"
    }, {
      label: "In what town or city did you meet your spouse/partner?",
      key: "In what town or city did you meet your spouse/partner?",
      value: "In what town or city did you meet your spouse/partner?"
    }, {
      label: "What is your favourite colour?",
      key: "What is your favourite colour?",
      value: "What is your favourite colour?"
    }, {
      label: "What is the name of your first grade teacher?",
      key: "What is the name of your first grade teacher?",
      value: "What is the name of your first grade teacher?"
    }, {
      label: "In what town or city was your first full time job?",
      key: "In what town or city was your first full time job?",
      value: "In what town or city was your first full time job?"
    }, {
      label: "Where did you go to high school/college?",
      key: "Where did you go to high school/college?",
      value: "Where did you go to high school/college?"
    }, {
      label: "What was the name of the first company that you worked for?",
      key: "What was the name of the first company that you worked for?",
      value: "What was the name of the first company that you worked for?"
    }],
    required: true,
    requiredMessage: "Please select a secret question",
    data: {
      width: "l"
    }
  }, {
    id: "securityAnswer",
    type: "text",
    label: "Answer",
    required: true,
    requiredMessage: "Please enter your secret answer",
    data: {
      width: "l"
    },
    validators: [{
      type: "isLength",
      data: {
        message: "Please enter at least {min} characters",
        options: {
          min: 4
        }
      }
    }]
  }, {
    id: "agreeTerms",
    label: "I agree to the terms and conditions",
    type: "checkbox",
    required: true
  }, {
    id: "emailAddress",
    label: "Please enter your email address",
    type: "text",
    validators: [{
      type: "isEmail"
    }],
    required: true,
    requiredMessage: "Please enter valid email",
    data: {
      width: "l"
    }
  }]
};

/**
 * Okta login form
 */
var SetPasswordAndQuestionForm = /*#__PURE__*/function (_React$Component) {
  _inherits(SetPasswordAndQuestionForm, _React$Component);

  var _super = _createSuper(SetPasswordAndQuestionForm);

  //region Properties
  function SetPasswordAndQuestionForm(props) {
    var _this;

    _classCallCheck(this, SetPasswordAndQuestionForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    var _schema = props.onInitilise(schema);

    var securityAnswer = _schema.fields.find(function (field) {
      return field.id === 'securityAnswer';
    });

    if (securityAnswer) {
      //security answer text and required message overrides
      if (_this.props.securityAnswerText) {
        securityAnswer.label = _this.props.securityAnswerText;
      }

      if (_this.props.securityAnswerRequiredText) {
        securityAnswer.requiredMessage = _this.props.securityAnswerRequiredText;
      }
    }

    _this.state = {
      isBusy: false,
      form: _Form.default.initialiseFromConfig(_schema),
      message: null,
      successful: false,
      linkExpired: false,
      resendSuccess: false
    };
    _this._service = new _IdentityService.default(props.identityBaseUrl, props.auth);
    _this.handleReactivationSubmit = _this.handleReactivationSubmit.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.hasLinkExpired = _this.hasLinkExpired.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SetPasswordAndQuestionForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true; // Get the token from the url and load the security question

      var token = _UrlUtils.default.getParam(window.location, 'token');

      if (token) {
        this._validateToken(token);
      } else {
        console.error('Missing recovery token in url');
        this.setState({
          message: _IdentityUtils.default.getErrorDetails(null),
          isBusy: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "getPasswordHeader",
    value: function getPasswordHeader() {
      var _this$props = this.props,
          showAdditionalPwHeader = _this$props.showAdditionalPwHeader,
          passwordHeader = _this$props.passwordHeader; // valid element has been passed a props no need to intervene

      if ( /*#__PURE__*/_react.default.isValidElement(passwordHeader)) {
        return passwordHeader;
      }

      var returnList = _constants.PASSWORD_HEADER_START;

      if (showAdditionalPwHeader) {
        // show additional password headers
        returnList += _constants.PASSWORD_HEADER_LIST_LONG;
      } else {
        returnList += _constants.PASSWORD_HEADER_LIST_SHORT;
      }

      return returnList;
    }
    /*
     * @function _validateToken checks is the token is valid.
     * This function sets stateToken (returned by the activeAccount API) which is valid for five minutes and is used only once
     */

  }, {
    key: "_validateToken",
    value: function () {
      var _validateToken2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token) {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  isBusy: true,
                  linkExpired: false
                });
                _context.prev = 1;
                _context.next = 4;
                return this._service.activateAccount(token);

              case 4:
                response = _context.sent;
                this.setState({
                  stateToken: response.stateToken,
                  id: response.id,
                  isBusy: false,
                  firstName: response.firstName,
                  lastName: response.lastName,
                  emailAddress: response.emailAddress
                });
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                if (_context.t0.name !== 'APIError') {
                  console.error(_context.t0);
                }

                this.props.onTokenExpired();

                if (this._isMounted) {
                  this.setState({
                    isBusy: false,
                    linkExpired: true
                  });
                }

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8]]);
      }));

      function _validateToken(_x) {
        return _validateToken2.apply(this, arguments);
      }

      return _validateToken;
    }()
    /*
     * @function handleReactivationSubmit
     * Api to send a Re Activate User
     */

  }, {
    key: "handleReactivationSubmit",
    value: function () {
      var _handleReactivationSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values) {
        var _this$props2, onError, onResend, portalIdentifier;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, onError = _this$props2.onError, onResend = _this$props2.onResend, portalIdentifier = _this$props2.portalIdentifier;
                this.setState({
                  isBusy: true,
                  message: null
                });
                _context2.prev = 2;
                _context2.next = 5;
                return this._service.resendActivationLink(values.emailAddress, portalIdentifier);

              case 5:
                this.setState({
                  resendSuccess: true
                });
                onResend();
                this.setState({
                  successful: true,
                  isBusy: false
                });
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                onError(_context2.t0);
                this.setState({
                  isBusy: false,
                  message: _IdentityUtils.default.getErrorDetails(_context2.t0.innerErrors)
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 10]]);
      }));

      function handleReactivationSubmit(_x2) {
        return _handleReactivationSubmit.apply(this, arguments);
      }

      return handleReactivationSubmit;
    }()
    /*
     * @function handleSubmit - Two scenarios captured here
     * Send a request to account activation API with required payload
     * If stateToken is expired take user to Link Expired Page
     */

  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(values) {
        var _this$props3, onWillProcess, onSuccess, onError, _this$state, stateToken, id;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = this.props, onWillProcess = _this$props3.onWillProcess, onSuccess = _this$props3.onSuccess, onError = _this$props3.onError;
                _this$state = this.state, stateToken = _this$state.stateToken, id = _this$state.id;
                onWillProcess(values);
                this.setState({
                  isBusy: true,
                  message: null
                });
                _context3.prev = 4;
                _context3.next = 7;
                return this._service.confirmAccountPostActivation(values.securityQuestion, values.securityAnswer, values.password, stateToken, id);

              case 7:
                onSuccess();
                this.setState({
                  successful: true,
                  isBusy: false
                });
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](4);
                onError(_context3.t0);
                /*
                 * TODO: Mulesoft to send us error code to differentiate Link Expiry and Unforseen errors
                 * Currently all errors take user to link expired page
                 */

                this.setState({
                  isBusy: false,
                  message: _IdentityUtils.default.getErrorDetails(_context3.t0.innerErrors) // linkExpired: true,

                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 11]]);
      }));

      function handleSubmit(_x3) {
        return _handleSubmit.apply(this, arguments);
      }

      return handleSubmit;
    }()
  }, {
    key: "hasLinkExpired",
    value: function hasLinkExpired() {
      var linkExpired = this.state.linkExpired;
      return linkExpired;
    }
    /*
     * Render function does couple of things
     * When stateToken is valid: Register Account Page form is rendered.
     * When stateToken is invalid: Expired Link Page is rendere.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          securityQuestionText = _this$props4.securityQuestionText,
          secretQuestions = _this$props4.secretQuestions,
          pleaseSelectText = _this$props4.pleaseSelectText,
          termsAndConditionsLabel = _this$props4.termsAndConditionsLabel,
          renderHeader = _this$props4.renderHeader,
          questionHeader = _this$props4.questionHeader,
          promptForTerms = _this$props4.promptForTerms,
          submitButtonText = _this$props4.submitButtonText,
          contentArea = _this$props4.contentArea,
          expiredLinkPageContent = _this$props4.expiredLinkPageContent,
          portalIdentifier = _this$props4.portalIdentifier,
          className = _this$props4.className;
      var _this$state2 = this.state,
          stateToken = _this$state2.stateToken,
          isBusy = _this$state2.isBusy,
          form = _this$state2.form,
          message = _this$state2.message,
          firstName = _this$state2.firstName,
          lastName = _this$state2.lastName,
          emailAddress = _this$state2.emailAddress,
          resendSuccess = _this$state2.resendSuccess;
      var securityQuestionOverrides = {},
          optionalTermsProps = {};
      var passwordHeader = this.getPasswordHeader();

      if (!stateToken) {
        if (isBusy) {
          return /*#__PURE__*/_react.default.createElement(_Spinner.default, {
            active: true
          });
        }

        if (message) {
          return /*#__PURE__*/_react.default.createElement(_Layout.default, {
            type: _Layout.default.Type.TWO_COLUMN_LEFT
          }, /*#__PURE__*/_react.default.createElement(_Message.default, {
            type: message.type,
            title: message.title
          }, message.body));
        }
      }

      if (securityQuestionText) {
        securityQuestionOverrides.label = securityQuestionText;
      }

      if (secretQuestions) {
        securityQuestionOverrides.options = [{
          disabled: true,
          label: pleaseSelectText || 'Please select',
          value: ''
        }].concat(_toConsumableArray(secretQuestions.map(function (question) {
          return {
            label: question,
            value: question
          };
        })));
      }

      if (termsAndConditionsLabel) {
        optionalTermsProps.label = termsAndConditionsLabel;
      }

      return /*#__PURE__*/_react.default.createElement(_Layout.default, {
        type: _Layout.default.Type.TWO_COLUMN_LEFT,
        aside: !this.hasLinkExpired() ? contentArea : null,
        className: "SetPasswordAndQuestionForm ".concat(className)
      }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        active: isBusy
      }, this.hasLinkExpired() ? /*#__PURE__*/_react.default.createElement(_ExpiredLinkPage.default, {
        content: expiredLinkPageContent,
        form: form,
        onSubmit: this.handleReactivationSubmit,
        resendSuccess: resendSuccess,
        portalIdentifier: portalIdentifier
      }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderHeader(firstName, lastName, emailAddress), /*#__PURE__*/_react.default.createElement(_GenericForm.default, {
        form: form,
        onSubmit: this.handleSubmit,
        className: "SetPasswordAndQuestionForm__GenericForm"
      }, /*#__PURE__*/_react.default.createElement(_RichText.default, {
        content: passwordHeader
      }), /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "password"
      }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_RichText.default, {
        content: questionHeader
      }), /*#__PURE__*/_react.default.createElement(_LayoutField.default, _extends({
        form: form,
        fieldId: "securityQuestion"
      }, securityQuestionOverrides)), /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "securityAnswer"
      }), promptForTerms && /*#__PURE__*/_react.default.createElement(_LayoutField.default, _extends({
        form: form,
        fieldId: "agreeTerms"
      }, optionalTermsProps)), message ? /*#__PURE__*/_react.default.createElement(_Message.default, {
        type: message.type,
        title: message.title
      }, message.body) : /*#__PURE__*/_react.default.createElement(_FormErrorSummary.default, {
        form: form,
        validateAfterSubmit: true
      }), /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "submit",
        disabled: isBusy
      }, submitButtonText)))));
    }
  }]);

  return SetPasswordAndQuestionForm;
}(_react.default.Component);

exports.default = SetPasswordAndQuestionForm;

_defineProperty(SetPasswordAndQuestionForm, "propTypes", {
  /**
   * Optional hook event used to modify the form config
   * For example zip with some content
   */
  onInitilise: _propTypes.default.func,

  /**
   * Success handler
   */
  onSuccess: _propTypes.default.func,

  /**
   *	On resetting email address
   */
  onResend: _propTypes.default.func,

  /**
   * Error event
   */
  onError: _propTypes.default.func,

  /**
   * Token expire event
   */
  onTokenExpired: _propTypes.default.func,

  /**
   * Identity base url
   */
  identityBaseUrl: _propTypes.default.string.isRequired,

  /**
   * Auth instance
   */
  auth: _propTypes.default.object.isRequired,

  /**
   * A new service attempt event
   */
  onWillProcess: _propTypes.default.func,

  /**
   * Header for password section. If not provided, then this component provides a default password guide based on showAdditionalPwHeader prop.
   */
  passwordHeader: _propTypes.default.node,

  /**
   * Header for secret question section
   */
  questionHeader: _propTypes.default.node,

  /**
   * Secret Questions
   */
  secretQuestions: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Submit button text
   */
  submitButtonText: _propTypes.default.string,

  /**
   * Show a terms and conditions checkbox
   */
  promptForTerms: _propTypes.default.bool,

  /**
   * Overrides the terms and conditions checkbox label
   */
  termsAndConditionsLabel: _propTypes.default.node,

  /**
   * Overrides the Security Question Text label
   */
  securityQuestionText: _propTypes.default.string,

  /**
   * Overrides the Security Please Select Text label
   */
  pleaseSelectText: _propTypes.default.string,

  /**
   * Overrides the Security Answer Text label
   */
  securityAnswerText: _propTypes.default.string,

  /**
   * Overrides the Security Answer  Required Text message
   */
  securityAnswerRequiredText: _propTypes.default.string,

  /**
   * State token from Okta
   */
  stateToken: _propTypes.default.string,

  /**
   * Id
   */
  id: _propTypes.default.string,

  /**
   * Optional header render
   * Function is passed in user details object
   */
  renderHeader: _propTypes.default.func,

  /*
   * Optional content area
   */
  contentArea: _propTypes.default.node,

  /*
   * Expired Link Page Content
   */
  expiredLinkPageContent: _propTypes.default.object,

  /*
   * portalIdentifier: If not passed will not render the resend email form
   */
  portalIdentifier: _propTypes.default.string,

  /*
   * showAdditionalPwHeader: FEATURE FLAG - show updated long pasword guide if no react element is passed to passwordHeader prop.
   */
  showAdditionalPwHeader: _propTypes.default.bool,
  className: _propTypes.default.string
});

_defineProperty(SetPasswordAndQuestionForm, "defaultProps", {
  onInitilise: function onInitilise(config) {
    return config;
  },
  submitButtonText: 'Create account',
  onError: function onError(err) {
    console.error(err);
  },
  onSuccess: function onSuccess() {},
  onWillProcess: function onWillProcess() {},
  onResend: function onResend() {},
  onTokenExpired: function onTokenExpired() {
    new Error('unhandled token expired method');
  },
  secretQuestions: null,
  questionHeader: "<h3>Set your secret question and answer</h3>\n\t\t\t<p>\n\t\t\t\tPlease select a secret question and it&apos;s corresponding answer. This will be used to\n\t\t\t\tvalidate your identity.\n\t\t\t</p>",
  promptForTerms: false,
  termsAndConditionsLabel: null,
  securityQuestionText: '',
  pleaseSelectText: '',
  securityAnswerText: '',
  securityAnswerRequiredText: '',
  stateToken: '',
  id: '',
  renderHeader: function renderHeader() {
    return null;
  },
  contentArea: null,
  portalIdentifier: null,
  expiredLinkPageContent: {},
  className: '',
  passwordHeader: null,
  showAdditionalPwHeader: false
});
//# sourceMappingURL=SetPasswordAndQuestionForm.js.map